(() => {
  'use strict';

  const SPECIAL_BUNDLE_TAG = 'KÜLÖNLEGES CSOMAGAJÁNLAT';
  const PAGEFLY_BUNDLE_SECTION_SELECTOR = '[data-section-id="pf-e803"]';
  const PRODUCT_BOX_SELECTOR = PAGEFLY_BUNDLE_SECTION_SELECTOR + ' [data-pf-type="ProductBox"][data-product-id]';
  const MEDIA_SELECTOR = '[data-pf-type="ProductMedia3"]';
  const BADGE_SELECTOR = '.tms-special-bundle-badge';
  const resultCache = Object.create(null);
  const pendingRequests = Object.create(null);

  function getPageFlyProduct(productId) {
    const products = window.__pageflyProducts || {};
    return products[String(productId)] || products[productId];
  }

  function addBadge(productBox, discountPercent) {
    const media = productBox.querySelector(MEDIA_SELECTOR);
    if (!media || media.querySelector(BADGE_SELECTOR)) {
      return;
    }

    const badgeText = discountPercent + '% KEDVEZMÉNY';
    const badge = document.createElement('span');
    badge.className = 'tms-special-bundle-badge';
    badge.setAttribute('aria-label', badgeText);
    badge.textContent = badgeText;
    media.appendChild(badge);
  }

  function resolveProduct(productBox) {
    const productId = productBox.getAttribute('data-product-id');
    const pageFlyProduct = getPageFlyProduct(productId);

    if (!productId || !pageFlyProduct || !pageFlyProduct.handle) {
      return;
    }

    if (typeof resultCache[productId] === 'number') {
      if (resultCache[productId] > 0) {
        addBadge(productBox, resultCache[productId]);
      }
      return;
    }

    if (pendingRequests[productId]) {
      pendingRequests[productId].push(productBox);
      return;
    }

    pendingRequests[productId] = [productBox];

    fetch('/products/' + encodeURIComponent(pageFlyProduct.handle) + '.js', {
      credentials: 'same-origin'
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Product JSON request failed: ' + response.status);
        }
        return response.json();
      })
      .then((product) => {
        const hasSpecialTag = Array.isArray(product.tags) && product.tags.indexOf(SPECIAL_BUNDLE_TAG) !== -1;
        const compareAtPrice = Number(product.compare_at_price);
        const currentPrice = Number(product.price);
        const discountPercent = hasSpecialTag && compareAtPrice > currentPrice && compareAtPrice > 0
          ? Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100)
          : 0;

        resultCache[productId] = discountPercent;
        if (discountPercent > 0) {
          pendingRequests[productId].forEach((box) => addBadge(box, discountPercent));
        }
      })
      .catch(() => {
        resultCache[productId] = 0;
      })
      .finally(() => {
        delete pendingRequests[productId];
      });
  }

  function scan() {
    document.querySelectorAll(PRODUCT_BOX_SELECTOR).forEach(resolveProduct);
  }

  let scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) {
      return;
    }

    scanScheduled = true;
    window.requestAnimationFrame(() => {
      scanScheduled = false;
      scan();
    });
  }

  function init() {
    scan();
    const observer = new MutationObserver(scheduleScan);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();